// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.svgContainer {\n  height: 40px;\n  width: 210px;\n}\n", ""]);
// Exports
module.exports = exports;
